import SrTable from "./index.vue";

SrTable.install = function(Vue) {
  Vue.component(SrTable.name, SrTable);
};

export default SrTable;



// WEBPACK FOOTER //
// ./packages/SrTable/index.js